'use client';

import { type TreatmentCategory } from '@/consts/treatmentCategories';
import { type Visit } from '@/services/visitsService/types';
import { useTrackPageEffect } from '@/utils/metrics';

/**
 * Wrapper component to handle page metrics. This component should only
 * be used in pages to ensure tracking when navigating between pages.
 * @see https://nextjs.org/docs/app/api-reference/file-conventions/page
 * @see https://nextjs.org/docs/app/api-reference/file-conventions/layout#layouts-do-not-receive-searchparams
 *
 */
export const TrackPage = ({
  title,
  treatmentCategory,
  currentUrl,
  visit,
}: {
  title: string;
  /**
   * This is nullable in cases where the treatment category isn't known (like find-your-treatment) but must be defined.
   * This is to prevent from a dev accidentally not passing the treatment category.
   */
  treatmentCategory: TreatmentCategory | null;
  currentUrl?: string;
  visit?: Visit;
}) => {
  useTrackPageEffect({
    title,
    treatmentCategory: treatmentCategory ?? undefined,
    currentUrl,
    visit,
  });

  return null;
};
